'use client';

import { twMerge } from '@shared/themes';
import { ROUTES } from '@shared/utils';
import { YourNumbersSection } from '../../../lottery-results/components/YourNumbersSection/YourNumbersSection';
import { isParticipationSettled, toDrawnLines } from '../../utils/participationResults/participationResults';
import { usePurchaseDetails } from '../context/PurchaseDetailsContext';

type PurchaseDetailsYourNumbersSectionProps = {
  className?: string;
};

/**
 * Renders the played numbers for the active participation as a results-page slip, with per-line prizes but no total footer.
 * Reads its data from `PurchaseDetailsProvider`, so it must be rendered inside it.
 */
function PurchaseDetailsYourNumbersSection({ className }: PurchaseDetailsYourNumbersSectionProps) {
  const { ticket, lotteryName, activeParticipation } = usePurchaseDetails();
  const { ticketId, lineInfo, currency } = ticket;

  return (
    <YourNumbersSection
      tickets={[
        {
          ticketId,
          lotteryName,
          lineInfo,
          drawnLines: toDrawnLines(activeParticipation, lotteryName, currency, lineInfo[lotteryName]),
          isDrawComplete: isParticipationSettled(activeParticipation),
        },
      ]}
      betUrl={ROUTES.LOTTO.LOTTERIES[lotteryName.toUpperCase() as keyof typeof ROUTES.LOTTO.LOTTERIES]}
      lotteryName={lotteryName}
      showTotalWinnings={false}
      className={twMerge('ll-container-inner', className)}
      data-track-container="Your Numbers"
    />
  );
}

export { PurchaseDetailsYourNumbersSection };
